import { render } from "./SelectComponent.vue?vue&type=template&id=49cdb786&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=49cdb786&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cdb786"]])

export default __exports__